export default {
  // margin: 'auto',
  boxSizing: 'border-box',
  borderRadius: '100%',
  animation: '$pulse 1s linear infinite',
  background: '#197AFA',
};
